/**
 * usage:
 *
 * ```
 * export default {
 *  mixins: [
 *   errorHandler
 * ],
 * ```
 *
 * then you can use it in your service calls' reject part:
 * `FooService.bar().then(this.onBarSuccess, this.onError)`
 *
 * in your view:
 * `<error-notice :errors="errors"></error-notice>`
 */

import { i18n } from '../main'

const ErrorHandler = {
  data: () => ({
    messages: []
  }),

  methods: {
    preSubmit () {
      this.messages = []
      if (typeof this.isLoading !== 'undefined') {
        this.isLoading = true
      }

      if (typeof this.isSuccess !== 'undefined') {
        this.isSuccess = false
      }
    },

    postSubmit () {
      if (typeof this.isLoading !== 'undefined') {
        this.isLoading = false
      }

      if (typeof this.isSuccess !== 'undefined') {
        this.isSuccess = true
      }
    },

    onError (errorResponse, errorsArrayName = 'messages', callback) {
      if (typeof this.isLoading !== 'undefined') {
        this.isLoading = false
      }

      if (!errorResponse) {
        return
      }

      let errors = []
      let response = errorResponse.response
      if (!response) {
        return
      }

      let data = response.data
      if (!data) {
        return
      }

      if (data.errors) {
        errors = data.errors.map(error => ({
          type: 'error',
          path: i18n.t(error.path),
          message: error.message
        }))
      } else if (data.message) {
        errors.push({
          type: 'error',
          message: data.message
        })
      }

      this[errorsArrayName] = errors || []
      if (typeof callback === 'function') {
        callback(errorResponse)
      }
    }
  }
}

export default ErrorHandler



// WEBPACK FOOTER //
// ./src/mixins/error-handler.js